import { Country, Department } from '../adapters/api-client/referential/Referential.model';

export const sortCountries = (countries: Country[]) => {
  return countries.sort((a, b) => {
    const stringA = a.label.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    const stringB = b.label.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    if (stringA < stringB) return -1;
    if (stringA > stringB) return 1;
    return 0;
  });
};

export const removeFranceFromCountries = (countries: Country[]) => {
  return countries.filter(({ countryCode }) => countryCode !== 'FR');
};

export const formattedDepartments = (departments: Department[]) => {
  return departments.map(({ label, code }) => ({ label, code, displayedLabel: `${code} - ${label}` }));
};
